/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 * Mirrors CBIGen Class.yaml EligibilityType; stored by name.
 * @export
 * @enum {string}
 */

export const ClassEligibilityTypeEnum = {
  MEMBERSHIP: "MEMBERSHIP",
  TIME_CONFLICT: "TIME_CONFLICT",
  SAME_TYPE_OTHER_INSTANCE: "SAME_TYPE_OTHER_INSTANCE",
  PREREQ: "PREREQ",
  OVERKILL: "OVERKILL",
} as const;

export type ClassEligibilityTypeEnum =
  (typeof ClassEligibilityTypeEnum)[keyof typeof ClassEligibilityTypeEnum];
export type ClassEligibilityTypeEnumEnumType = typeof ClassEligibilityTypeEnum;
export type ClassEligibilityTypeEnumOptional = ClassEligibilityTypeEnum;
export type ClassEligibilityTypeEnumTrackedI = ClassEligibilityTypeEnum;
export type ClassEligibilityTypeEnumTracked = ClassEligibilityTypeEnum;
export type ClassEligibilityTypeEnumMetaI = EnumMetaType<
  ClassEligibilityTypeEnumEnumType,
  ClassEligibilityTypeEnum
>;
export const ClassEligibilityTypeEnumMeta = typeMetaEnum<
  ClassEligibilityTypeEnumEnumType,
  ClassEligibilityTypeEnum
>("ClassEligibilityTypeEnum", ClassEligibilityTypeEnum);
export function transformDatesClassEligibilityTypeEnum(
  model: ClassEligibilityTypeEnum,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
